import React, { useContext } from 'react'
import styled from 'styled-components'
import Color from './color'
import Font from './font'
import Size from './size'
import Stroke from './stroke'
import { CreationSourceEditorContext } from '../../manager'

const Container = styled.div`
    display: flex;
    grid-column: span 8;
    margin: -20px -15px 0;
    > div {
        margin-right: 10px;
    }
    > div:last-child {
        margin-right: 0;
    }
`

const CreationSourceEditorCaptionDropdowns = () => {
    const { captionStyle, setCaptionStyle, customFontUrl } = useContext(CreationSourceEditorContext)

    return (
        <Container>
            <Font captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} customFontUrl={customFontUrl} />
            <Size captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
            <Color captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
            <Stroke captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
        </Container>
    )
}

export default CreationSourceEditorCaptionDropdowns
